<ng-container *ngFor="let session of sessions">
    <button mat-menu-item (click)="onSessionClick(session)">
        {{ session.display }}
    </button>
</ng-container>
